import applicationUserManager from '../applicationusermanager'
import { notifyHelper } from './notifyHelper';
import { store } from '../store/store';
export function responseCheck(status) {
    if (status === 400) {
        notifyHelper('error', 'please check you entries especially date format');
    }
    else if (status === 401) {
        notifyHelper('error', 'Session has already expired please re login!');
        store.dispatch("logout")
        applicationUserManager.logout401()
    }
    else if (status === 403) {
        notifyHelper('info', 'You are not allowed to access this resource!');
    }
    else if (status === 413) {
        notifyHelper('error', 'The size of the file you are uploading exceeds that of the maximum allowable size')
    }
    else if (status === 404) {
        notifyHelper('warn', 'Cannot find the resource you are looking to download or preview, or the images on the document are not supported!')
    }
    else if (status === 408) {
        notifyHelper('error', 'There was an issue connecting to the database server!, the error has been logged and notified CSD,DV!')
    }
    else {
        notifyHelper('error', 'There was an error processing your request, the error has been logged and notified CSD,DV!')
    }
}